
var Mediator = require('./Mediator.js');
var util = require('../util.js');
var storeHelper = require('../storeHelper');
var MOUSE_STATE = {'DOWN': 'down', 'MOVE': 'move', 'RELEASE': 'release'};

var layerEventsTemp = {
  mousedown: 'layerMouseDown',
  mousemove: 'layerMouseMove',
};
var canvasEventsTemp = {
  onmousedown: 'canvasMouseDown', 
  onmousemove: 'canvasMouseMove',
  onmouseup: 'canvasMouseUp'
};
var beginX = -1;
var beginY = -1;
var filledMin = 5;

/**
 * 管理各个工具的绘制数据
 */
var Tool = {

    templetePoint: {
      strokeWidth: 1,
      strokeStyle: '#000',
      fillStyle: '#fff',
      groups: ['points'],
      fromCenter: true,
      type: 'ellipse',
      width: 6,
      height: 6,
    },

    initStyle: function() {
      var strokeStyle = {color: '#fb3838', strokeWidth: 2};
      var fillStyle = {backColor: '#fb3838', backColorAlpha: 0.3};
      var textStyle = {backColor: '#fff29f', color: '#fb3838', fontSize: 16, backColorAlpha: 1};
      if(!storeHelper.get('RectTool')) {
        storeHelper.set('RectTool', JSON.stringify(strokeStyle));
      }
      if(!storeHelper.get('EllipseTool')) {
        storeHelper.set('EllipseTool', JSON.stringify(strokeStyle));
      }
      if(!storeHelper.get('ArrowTool')) {
        storeHelper.set('ArrowTool', JSON.stringify(strokeStyle));
      }
      if(!storeHelper.get('PencilTool')) {
        storeHelper.set('PencilTool', JSON.stringify(strokeStyle));
      }
      if(!storeHelper.get('FilledRectTool')) {
        storeHelper.set('FilledRectTool', JSON.stringify(fillStyle));
      }
      if(!storeHelper.get('FilledEllipseTool')) {
        storeHelper.set('FilledEllipseTool', JSON.stringify(fillStyle));
      }
      if(!storeHelper.get('TextTool')) {
        storeHelper.set('TextTool', JSON.stringify(textStyle));
      }
    },
    setStyle: function(tool, styleKey, value) {
      var style = JSON.parse(storeHelper.get(tool));
      style[styleKey] = value;
      storeHelper.set(tool, JSON.stringify(style));
    },

    getStyle: function(tool, styleKey) {
      var style = JSON.parse(storeHelper.get(tool));
      return style[styleKey];
    },
    getBackColor: function(tool) {
      var style = JSON.parse(storeHelper.get(tool));
      var rgb = util.Color.toRGB(style.backColor);
      return 'rgba('+rgb.r+','+rgb.g+','+rgb.b+','+style.backColorAlpha+')';
    },

    RectTool: {

      layerEvents: layerEventsTemp,
      canvasEvents: canvasEventsTemp,

      moveLayer: 'moveShapeLayer',
      dragBorder: 'dragShapeBorder',
      initCheckPoint: 'initShapePoint',

      templete: {type: 'rectangle', fromCenter: false},
      data: {tool: 'RectTool'},

      //响应鼠标动作，生成图层数据
      drawingData: function (newX, newY, state) {
        var strokeWidth = Tool.getStyle('RectTool', 'strokeWidth');
        var obj = $.extend({}, this.templete, {
          strokeStyle: Tool.getStyle('RectTool', 'color'),
          strokeWidth: strokeWidth,
        });
        var data = $.extend({}, this.data, {
          author: storeHelper.get('sign'),
          id: -1,
          cid: Mediator.getCid(),
          pageX: Mediator.getProps('fullPageLocation').left,
          pageY: Mediator.getProps('fullPageLocation').top
        });
        obj.data = data;

        var pxOff = (strokeWidth % 2) / 2;
        var draw = function (beginX, beginY, newX, newY) {
          obj.x = Math.min(beginX, newX) + pxOff;
          obj.y = Math.min(beginY, newY) + pxOff;
          obj.width = Math.abs(newX - beginX);
          obj.height = Math.abs(newY - beginY);
        };
        if (state === MOUSE_STATE.DOWN) {
          beginX = newX;
          beginY = newY;
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.MOVE) {
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.RELEASE) {
          draw(beginX, beginY, newX, newY);
        }
        if(obj.width < strokeWidth/2 || obj.height < strokeWidth/2) {
          return null;
        }

        return obj;
      },

      exportData: function (layer) {
        var obj = $.extend({}, this.templete, {
          data: layer.data,
          strokeStyle: layer.strokeStyle,
          strokeWidth: layer.strokeWidth,
          width: layer.width,
          height: layer.height,
          x: layer.x, y: layer.y
        });
        obj.data.index = layer.index;
        return obj;
      },

      reloadData: function(obj, pageLocation) {
        if(pageLocation) {
          var dx = pageLocation.left - obj.data.pageX;
          var dy = pageLocation.top - obj.data.pageY;
          obj.x += dx;
          obj.y += dy;
          obj.data.pageX = pageLocation.left;
          obj.data.pageY = pageLocation.top;
        }
      }
    },

    FilledRectTool: {

      layerEvents: layerEventsTemp,
      canvasEvents: canvasEventsTemp,

      moveLayer: 'moveShapeLayer',
      dragBorder: 'dragShapeBorder',
      initCheckPoint: 'initShapePoint',

      templete: {type: 'rectangle', fromCenter: false},
      data: {tool: 'FilledRectTool'},

      //响应鼠标动作，生成图层数据
      drawingData: function (newX, newY, state) {
        var obj = $.extend({}, this.templete, {
          fillStyle: Tool.getBackColor('FilledRectTool'),
        });
        var data = $.extend({}, this.data, {
          author: storeHelper.get('sign'),
          id: -1,
          cid: Mediator.getCid(),
          pageX: Mediator.getProps('fullPageLocation').left,
          pageY: Mediator.getProps('fullPageLocation').top
        });
        obj.data = data;

        var draw = function (beginX, beginY, newX, newY) {
          obj.x = Math.min(beginX, newX);
          obj.y = Math.min(beginY, newY);
          obj.width = Math.abs(newX - beginX);
          obj.height = Math.abs(newY - beginY);
        };
        if (state === MOUSE_STATE.DOWN) {
          beginX = newX;
          beginY = newY;
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.MOVE) {
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.RELEASE) {
          draw(beginX, beginY, newX, newY);
        }
        if (obj.width < filledMin && obj.height < filledMin) {
          return null;
        }

        return obj;
      },

      exportData: function (layer) {
        var obj = $.extend({}, this.templete, {
          data: layer.data,
          fillStyle: layer.fillStyle,
          width: layer.width,
          height: layer.height,
          x: layer.x, y: layer.y
        });
        obj.data.index = layer.index;
        return obj;
      },

      reloadData: function(obj, pageLocation) {
        if(pageLocation) {
          var dx = pageLocation.left - obj.data.pageX;
          var dy = pageLocation.top - obj.data.pageY;
          obj.x += dx;
          obj.y += dy;
          obj.data.pageX = pageLocation.left;
          obj.data.pageY = pageLocation.top;
        }
      }
    },

    EllipseTool: {

      layerEvents: layerEventsTemp,
      canvasEvents: canvasEventsTemp,

      moveLayer: 'moveShapeLayer',
      dragBorder: 'dragShapeBorder',
      initCheckPoint: 'initShapePoint',

      templete: {type: 'ellipse', fromCenter: false},
      data: {tool: 'EllipseTool'},

      //响应鼠标动作，生成图层数据
      drawingData: function (newX, newY, state) {
        var strokeWidth = Tool.getStyle('EllipseTool', 'strokeWidth');
        var obj = $.extend({}, this.templete, {
          strokeStyle: Tool.getStyle('EllipseTool', 'color'),
          strokeWidth: strokeWidth,
        });
        var data = $.extend({}, this.data, {
          author: storeHelper.get('sign'),
          id: -1,
          cid: Mediator.getCid(),
          pageX: Mediator.getProps('fullPageLocation').left,
          pageY: Mediator.getProps('fullPageLocation').top
        });
        obj.data = data;
        var draw = function (beginX, beginY, newX, newY) {
          obj.x = Math.min(beginX, newX);
          obj.y = Math.min(beginY, newY);
          obj.width = Math.abs(newX - beginX);
          obj.height = Math.abs(newY - beginY);
        };
        if (state === MOUSE_STATE.DOWN) {
          beginX = newX;
          beginY = newY;
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.MOVE) {
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.RELEASE) {
          draw(beginX, beginY, newX, newY);
        }
        if (obj.width < strokeWidth/2 && obj.height < strokeWidth/2) {
          return null;
        }

        return obj;
      },

      exportData: function (layer) {
        var obj = $.extend({}, this.templete, {
          data: layer.data,
          strokeStyle: layer.strokeStyle,
          strokeWidth: layer.strokeWidth,
          width: layer.width,
          height: layer.height,
          x: layer.x, y: layer.y
        });
        obj.data.index = layer.index;
        return obj;
      },

      reloadData: function(obj, pageLocation) {
        if(pageLocation) {
          var dx = pageLocation.left - obj.data.pageX;
          var dy = pageLocation.top - obj.data.pageY;
          obj.x += dx;
          obj.y += dy;
          obj.data.pageX = pageLocation.left;
          obj.data.pageY = pageLocation.top;
        }
      }
    },

    FilledEllipseTool: {

      layerEvents: layerEventsTemp,
      canvasEvents: canvasEventsTemp,

      moveLayer: 'moveShapeLayer',
      dragBorder: 'dragShapeBorder',
      initCheckPoint: 'initShapePoint',

      templete: {type: 'ellipse', fromCenter: false},
      data: {tool: 'FilledEllipseTool'},

      //响应鼠标动作，生成图层数据
      drawingData: function (newX, newY, state) {
        var obj = $.extend({}, this.templete, {
          fillStyle: Tool.getBackColor('FilledEllipseTool'),
        });
        var data = $.extend({}, this.data, {
          author: storeHelper.get('sign'),
          id: -1,
          cid: Mediator.getCid(),
          pageX: Mediator.getProps('fullPageLocation').left,
          pageY: Mediator.getProps('fullPageLocation').top
        });
        obj.data = data;
        var draw = function (beginX, beginY, newX, newY) {
          obj.x = Math.min(beginX, newX);
          obj.y = Math.min(beginY, newY);
          obj.width = Math.abs(newX - beginX);
          obj.height = Math.abs(newY - beginY);
        };
        if (state === MOUSE_STATE.DOWN) {
          beginX = newX;
          beginY = newY;
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.MOVE) {
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.RELEASE) {
          draw(beginX, beginY, newX, newY);
        }
        if (obj.width < filledMin && obj.height < filledMin) {
          return null;
        }

        return obj;
      },

      exportData: function (layer) {
        var obj = $.extend({}, this.templete, {
          data: layer.data,
          fillStyle: layer.fillStyle,
          width: layer.width,
          height: layer.height,
          x: layer.x, y: layer.y
        });
        obj.data.index = layer.index;
        return obj;
      },

      reloadData: function(obj, pageLocation) {
        if(pageLocation) {
          var dx = pageLocation.left - obj.data.pageX;
          var dy = pageLocation.top - obj.data.pageY;
          obj.x += dx;
          obj.y += dy;
          obj.data.pageX = pageLocation.left;
          obj.data.pageY = pageLocation.top;
        }
      }
    },

    ArrowTool: {

      layerEvents: layerEventsTemp,
      canvasEvents: canvasEventsTemp,

      moveLayer: 'moveLineLayer',
      dragBorder: 'dragArrowBorder',
      initCheckPoint: 'initArrowPoint',

      templete: {
        type: 'line',
        fromCenter: false,
        rounded: true,
        endArrow: true,
      },
      data: {tool: 'ArrowTool'},

      //响应鼠标动作，生成图层数据
      drawingData: function (newX, newY, state) {
        var strokeWidth = Tool.getStyle('ArrowTool', 'strokeWidth');
        var obj = $.extend({}, this.templete, {
          strokeStyle: Tool.getStyle('ArrowTool', 'color'),
          strokeWidth: strokeWidth,
        });
        var data = $.extend({}, this.data, {
          author: storeHelper.get('sign'),
          id: -1,
          cid: Mediator.getCid(),
          pageX: Mediator.getProps('fullPageLocation').left,
          pageY: Mediator.getProps('fullPageLocation').top
        });
        obj.data = data;
        var draw = function (beginX, beginY, newX, newY) {
          obj.x1 = beginX;
          obj.y1 = beginY;
          obj.x2 = newX;
          obj.y2 = newY;
        };
        if (state === MOUSE_STATE.DOWN) {
          beginX = newX;
          beginY = newY;
          obj.visible = false;
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.MOVE) {
          obj.visible = true;
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.RELEASE) {
          draw(beginX, beginY, newX, newY);
        }
        Mediator.setArrowSize(obj);
        var d = Math.sqrt(Math.pow(newX - beginX, 2) + Math.pow(newY - beginY, 2));
        if (d < 10) {
          return null;
        }

        return obj;
      },

      exportData: function (layer) {
        var obj = $.extend({}, this.templete, {
          data: layer.data,
          strokeStyle: layer.strokeStyle,
          strokeWidth: layer.strokeWidth,
          arrowRadius: layer.arrowRadius,
          arrowAngle: layer.arrowAngle,
          x1: layer.x1, y1: layer.y1,
          x2: layer.x2, y2: layer.y2
        });
        obj.data.index = layer.index;
        return obj;
      },

      reloadData: function(obj, pageLocation) {
        if(pageLocation) {
          var dx = pageLocation.left - obj.data.pageX;
          var dy = pageLocation.top - obj.data.pageY;
          obj.x1 += dx;
          obj.y1 += dy;
          obj.x2 += dx;
          obj.y2 += dy;
          obj.data.pageX = pageLocation.left;
          obj.data.pageY = pageLocation.top;
        }
      }
    },

    PencilTool: {
      path: [],

      layerEvents: layerEventsTemp,
      canvasEvents: canvasEventsTemp,

      moveLayer: 'moveLineLayer',
      dragBorder: 'dragPencilBorder',
      initCheckPoint: 'initPencilPoint',

      templete: {
        type: 'line',
        fromCenter: false,
        rounded: true,
      },

      data: {tool: 'PencilTool'},

      //响应鼠标动作，生成图层数据
      drawingData: function (newX, newY, state) {
        var obj = $.extend({}, this.templete, {
          strokeStyle: Tool.getStyle('PencilTool', 'color'),
          strokeWidth: Tool.getStyle('PencilTool', 'strokeWidth'),
        });
        var data = $.extend({}, this.data, {
          author: storeHelper.get('sign'),
          id: -1,
          cid: Mediator.getCid(),
          rowWidth: Tool.getStyle('PencilTool', 'strokeWidth'),
          pageX: Mediator.getProps('fullPageLocation').left,
          pageY: Mediator.getProps('fullPageLocation').top
        });
        obj.data = data;

        if (state === MOUSE_STATE.DOWN) {
          this.path = [];
        }
        this.path.push([newX, newY]);
        for (var i = 0; i < this.path.length; i++) {
          obj['x' + (i + 1)] = this.path[i][0];
          obj['y' + (i + 1)] = this.path[i][1];
        }
        if (state === MOUSE_STATE.MOVE) {
          obj.visible = true;
        }
        var len = this.path.length;
        if (state === MOUSE_STATE.RELEASE) {
          this.path = [];
        }
        if(len <= 5) {
          return null;
        }
        return obj;
      },

      exportData: function (layer) {
        var obj = $.extend({}, this.templete, {
          strokeStyle: layer.strokeStyle,
          strokeWidth: layer.strokeWidth,
          data: layer.data,
        });

        var j = 1;
        while (true) {
          var x = layer['x' + j];
          var y = layer['y' + j];
          if (x === undefined || y === undefined) {
            break;
          }
          obj['x' + j] = x;
          obj['y' + j] = y;
          j++;
        }
        obj.data.index = layer.index;
        return obj;
      },

      reloadData: function(obj, pageLocation) {
        if(pageLocation) {
          var dx = pageLocation.left - obj.data.pageX;
          var dy = pageLocation.top - obj.data.pageY;
          var j = 1;
          while (true) {
            var x = obj['x' + j];
            var y = obj['y' + j];
            if (x === undefined || y === undefined) {
              break;
            }
            obj['x' + j] += dx;
            obj['y' + j] += dy;
            j++;
          }
          obj.data.pageX = pageLocation.left;
          obj.data.pageY = pageLocation.top;
        }
      }
    },

    TextTool: {
      bindId: 1,

      layerEvents: $.extend({}, layerEventsTemp, {
        dblclick: 'layerDblClick'
      }),
      canvasEvents: {
        onmousedown: 'canvasMouseDown', onmousemove: 'canvasMouseMove',
        onmouseup: 'drawUpWithText'
      },

      moveLayer: 'moveTextLayer',
      dragBorder: 'dragTextBorder',
      initCheckPoint: 'initTextPoint',

      wrapTemplete: {
        type: 'rectangle',
        fromCenter: false,
      },

      textTemplete: {
        type: 'text',
        fromCenter: false,
        align: 'left',
        fontFamily: '微软雅黑',
      },
      wrapData: {
        tool: 'TextTool',
        relativeIndex: 0,
      },
      textData: {
        tool: 'TextTool',
        relativeIndex: 1,
      },

      drawingData: function (newX, newY, state) {
        var obj = $.extend({}, this.wrapTemplete, {});
        var data = $.extend({}, this.wrapData, {
          author: storeHelper.get('sign'),
          id: -1,
          cid: Mediator.getCid(),
          bindId: this.bindId,
          pageX: Mediator.getProps('fullPageLocation').left,
          pageY: Mediator.getProps('fullPageLocation').top
        });
        obj.data = data;

        var draw = function (beginX, beginY, newX, newY) {
          obj.x = Math.min(beginX, newX);
          obj.y = Math.min(beginY, newY);
          obj.width = Math.abs(newX - beginX);
          obj.height = Math.abs(newY - beginY);
        };
        if (state === MOUSE_STATE.DOWN) {
          obj.strokeDash = [5];
          obj.strokeDashOffset = 0;
          obj.strokeStyle = '#606060';
          beginX = newX;
          beginY = newY;
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.MOVE) {
          obj.strokeDash = [5];
          obj.strokeDashOffset = 0;
          obj.strokeStyle = '#606060';
          draw(beginX, beginY, newX, newY);
        }
        if (state === MOUSE_STATE.RELEASE) {
          obj.strokeDash = undefined;
          obj.strokeDashOffset = undefined;
          obj.strokeStyle = undefined;
          obj.fillStyle = Tool.getBackColor('TextTool');
          draw(beginX, beginY, newX, newY);
          this.bindId++;
        }
        if (obj.width < filledMin && obj.height < filledMin) {
          return null;
        }

        return obj;
      },

      appendText: function (backLayer, value) {
        var obj = $.extend({}, this.textTemplete, {
          fillStyle: Tool.getStyle('TextTool', 'color'),
          fontSize: Tool.getStyle('TextTool', 'fontSize'),
          x: Math.min(backLayer.x, backLayer.x+backLayer.width)+10,
          y: Math.min(backLayer.y, backLayer.y+backLayer.height)+10,
        });
        var data = $.extend({}, this.textData, {
          author: storeHelper.get('sign'),
          id: -1,
          cid: Mediator.getCid(),
          bindId: backLayer.data.bindId,
          text: value,
          pageX: Mediator.getProps('fullPageLocation').left,
          pageY: Mediator.getProps('fullPageLocation').top
        });
        obj.data = data;

        obj.text = Mediator.figureTextWidth(value, obj, backLayer);
        return obj;
      },

      exportData: function (layer) {
        var obj;
        if (layer.data.relativeIndex === 0) {        //背景矩形
          obj = $.extend({}, this.wrapTemplete, {
            data: layer.data,
            fillStyle: layer.fillStyle,
            width: layer.width,
            height: layer.height,
            x: layer.x, y: layer.y
          });
        } else {
          obj = $.extend({}, this.textTemplete, {
            data: layer.data,
            fillStyle: layer.fillStyle,
            fontSize: layer.fontSize,
            fontFamily: layer.fontFamily,
            text: layer.text,
            x: layer.x, y: layer.y
          });
        }
        obj.data.index = layer.index;
        return obj;
      },

      reloadData: function(obj, pageLocation) {
        //刚加载时，要考虑bindId已经被使用
        if(obj.data.bindId >= this.bindId) {
          this.bindId = obj.data.bindId + 1;
        }
        if(pageLocation) {
          var dx = pageLocation.left - obj.data.pageX;
          var dy = pageLocation.top - obj.data.pageY;
          obj.x += dx;
          obj.y += dy;
          obj.data.pageX = pageLocation.left;
          obj.data.pageY = pageLocation.top;
        }
      }
    },
};


module.exports = Tool;


// WEBPACK FOOTER //
// ./src/helper/Review/PaintTool.js